import { render, staticRenderFns } from "./PresenceWarningTable.vue?vue&type=template&id=7ed16e47"
import script from "./PresenceWarningTable.vue?vue&type=script&lang=js"
export * from "./PresenceWarningTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports